import { Button, Chips, FormField } from '@cian/ui-kit';
import { FURNITURE, REPAIR, ROOMS_COUNT } from './constants';

export type TThirdStepFormProps = {
  onRoomsCount: (value: string[]) => void;
  roomsCount: string[];
  onRepair: (value: string[]) => void;
  repair: string[];
  onFurniture: (value: string[]) => void;
  furniture: string[];
  onNextBtn: VoidFunction;
  isLoading: boolean;
};

export const ThirdStepForm: React.FC<TThirdStepFormProps> = ({
  roomsCount,
  onRoomsCount,
  repair,
  onRepair,
  furniture,
  onFurniture,
  onNextBtn,
  isLoading,
}) => {
  return (
    <div>
      <FormField label="Сколько комнат в квартире">
        <Chips value={roomsCount} onChange={onRoomsCount} options={ROOMS_COUNT} />
      </FormField>
      <FormField label="Какой ремонт">
        <Chips value={repair} onChange={onRepair} options={REPAIR} />
      </FormField>
      <FormField label="Мебель в квартире">
        <Chips value={furniture} onChange={onFurniture} options={FURNITURE} />
      </FormField>
      <Button size="M" loading={isLoading} onClick={onNextBtn} fullWidth>
        Дальше
      </Button>
    </div>
  );
};
